import {
  Button,
  Col,
  Flex,
  Grid,
  Row,
  Skeleton,
  Tag,
  theme,
  Typography,
} from "antd";
import { startCase } from "lodash-es";
import moment from "moment";
import React from "react";

import { H1JobTitle, StyledLabel } from "./styled";
import { HeaderProps } from "./types";

import { ArrowBackground } from "~/Atom/ArrowBackground";

export const Header: React.FC<HeaderProps> = ({
  jobData,
  handleClick,
  isLoading,
}) => {
  const breakpoints = Grid.useBreakpoint();

  const { token } = theme.useToken();

  const params = new URLSearchParams(window.location.search);

  return (
    <Row>
      <Col
        span={24}
        style={{
          textAlign: "center",
        }}
      >
        <Col xs={24}>
          {jobData?.google.job?.customAttributes.department_names?.stringValues.map(
            (v) => (
              <Tag
                key={v}
                style={{
                  borderColor: token.colorTextSecondary,
                  color: token.colorTextSecondary,
                  padding: ".25rem 1rem",
                  textTransform: "uppercase",
                  background: token.colorWhite,
                  zIndex: 10,
                }}
              >
                {v}
              </Tag>
            )
          ) ||
            (params.get("gh_job_department") || jobData ? (
              <Tag
                style={{
                  zIndex: 1,
                  background: token.colorWhite,
                  borderColor: token.colorTextSecondary,
                  color: token.colorTextSecondary,
                  padding: ".25rem 1rem",
                  textTransform: "uppercase",
                }}
              >
                {params.get("gh_job_department") || "EquipmentShare"}
              </Tag>
            ) : (
              <Skeleton.Button shape="square" size="small" active={true} />
            ))}
        </Col>
        <Col xs={24}>
          <ArrowBackground
            style={{
              position: "absolute",
              left: "75",
              top: "-25",
              opacity: "70%",
            }}
          />
          <H1JobTitle $breakpoints={breakpoints} level={1}>
            {jobData?.greenhouse?.title || params.get("gh_job_title") || (
              <Skeleton.Button
                shape="square"
                size="large"
                block={true}
                active={true}
              />
            )}
          </H1JobTitle>
          {
            <div
              style={{
                margin: "auto",
                marginBottom: "1rem !important",
                maxWidth: "40rem",
              }}
            >
              {/* {jobData.google.job.customAttributes?.office_names?.stringValues.map(
                (office_name) => {
                  return (
                    <Tag
                      style={{
                        borderColor: token.colorPrimary,
                        color: token.colorPrimary,
                        padding: ".125rem .5rem",
                        margin: ".1rem",
                      }}
                    >
                      {office_name}
                    </Tag>
                  );
                }
              )} */}
            </div>
          }
        </Col>
        <Row style={{ marginTop: "1rem", maxWidth: "20rem", margin: "auto" }}>
          <Col xs={24}>
            <Button
              disabled={isLoading}
              block
              type="primary"
              onClick={handleClick}
              style={{ marginBottom: "1rem" }}
            >
              {"Apply Now"}
            </Button>
          </Col>

          {jobData ? (
            <>
              <Col flex={"50%"} style={{ textAlign: "left" }}>
                <Flex vertical={true}>
                  <StyledLabel>{"Date Posted"}</StyledLabel>

                  <Typography.Text>
                    {jobData?.google.job.postingUpdateTime?.seconds ||
                    params.get("gh_job_posting_date") ? (
                      moment(
                        Number(
                          jobData?.google.job.postingUpdateTime?.seconds ?? 0
                        ) * 1000 || params.get("gh_job_posting_date")
                      ).format("MMMM D, YYYY")
                    ) : (
                      <Skeleton.Button
                        shape="square"
                        size="small"
                        active={true}
                      />
                    )}
                  </Typography.Text>
                </Flex>
              </Col>

              <Col
                flex={"50%"}
                style={{ textAlign: "right", paddingLeft: ".5rem" }}
              >
                <Flex vertical={true}>
                  {(jobData?.greenhouse?.metadata.at(0)?.value ||
                    params.get("gh_job_employment_type")) && (
                    <>
                      <StyledLabel style={{ textAlign: "left" }}>
                        {"Employment Type"}
                      </StyledLabel>

                      <Typography.Text style={{ textAlign: "left" }}>
                        {startCase(
                          jobData?.greenhouse?.metadata.at(0)?.value ||
                            params.get("gh_job_employment_type")
                        )}
                      </Typography.Text>
                    </>
                  )}
                </Flex>
              </Col>
            </>
          ) : (
            <Col span={24} style={{ textAlign: "left" }}>
              <Skeleton
                title={{ width: "80%", style: { marginTop: 2 } }}
                paragraph={{
                  rows: 1,
                  width: "60%",
                  style: { marginTop: 10, marginBottom: 12 },
                }}
                active={true}
                style={{ height: 56 }}
              />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};
